module.exports = __webpack_public_path__ + "static/media/login-footer.18fd2ac0.png";